// utils/logger.ts
import pino from 'pino'

const isProduction = process.env.NODE_ENV === 'production'

const getLogger = (name: string) => pino({
  name,
  level: isProduction ? 'info' : 'debug',
  browser: {
    asObject: true,
  },
  // In production, use pino's default (raw NDJSON to stdout) — no transport worker threads,
  // which fail in AWS/Next.js standalone deployments.
  // In development, use pino-pretty for readable output.
  ...(!isProduction && {
    transport: {
      target: 'pino-pretty',
      options: {
        colorize: true,
        translateTime: 'SYS:standard',
        ignore: 'pid,hostname',
      },
    },
  }),
})

export default getLogger
